// extracted by mini-css-extract-plugin
export default {"wrap":"JK-z","fullWidth":"KK-z","hideOnDesktop":"LK-z","content":"MK-z","hasOpenedNav":"NK-z","crumbsList":"OK-z","dropdownsWrap":"PK-z"};